import api from "../index"

const platformManagerApi = api.injectEndpoints({
  endpoints: (build) => ({
    updatePaswword: build.mutation({
      query: (body) => ({
        url: `/platform-manager/change-password`,
        method: "PUT",
        body,
      }),
    }),
    storeSystemConfig: build.mutation({
      query: (body) => ({
        url: `/platform-manager`,
        method: "POST",
        body,
      }),
    }),
    getStoreConfigs: build.query({
      query: () => ({
        url: `/platform-manager/`,
        method: "GET",
      }),
    }),
  }),
})

export const {
  useUpdatePaswwordMutation,
  useStoreSystemConfigMutation,
  useLazyGetStoreConfigsQuery,
} = platformManagerApi
